import {
  OrderGetResponseType,
  OrderPaymentType,
  SupplierRelationshipListResponseType,
} from "@sellar-io/api-v2/types";
import dayjs from "dayjs";
import { ReactElement } from "react";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { OrderStage } from "../../helpers";
import { useInvoiceCreationStage } from "../../../paymentTypeIndicator/useInvoiceCreationStage";

type OrderSummaryStatusPaymentTermsType =
  | SupplierRelationshipListResponseType[number]["paymentTerms"]
  | null;
export type OrderSummaryStatusPaymentMessageType = {
  paymentDue?: Date | null;
  paidAt?: Date | null;
  paymentStatus: OrderGetResponseType["paymentStatus"];
  orderStage: OrderStage;
  cancelledAt: Date | null;
  invoiceIssuedAt: Date | null;
  requestedAt: Date | null;
  invoiceCreationStage: OrderGetResponseType["Supplier"]["invoiceCreationStage"];
  paymentType: OrderPaymentType | null;
  paymentTerms?: OrderSummaryStatusPaymentTermsType;
  orderPrice: number;
};

export const OrderSummaryStatusPaymentMessage = ({
  paidAt,
  paymentDue,
  paymentStatus,
  orderStage,
  cancelledAt,
  invoiceIssuedAt,
  requestedAt,
  invoiceCreationStage,
  paymentTerms,
  paymentType,
  orderPrice,
}: OrderSummaryStatusPaymentMessageType): ReactElement | null => {
  const { business } = useSellarCurrentBusiness();
  const dateFormat = "DD/MM/YY HH:mm A";
  const paymentTermsText = useInvoiceCreationStage({
    isBuyer: !!business?.Retailer,
    invoiceCreationStage,
    paymentTerms,
    paymentType,
  });
  if (paymentStatus === "refunded") {
    return (
      <small className={"text-zinc-500"}>
        Refunded on {dayjs(cancelledAt).format(dateFormat)}
      </small>
    );
  }

  if (orderStage === "Cancelled") {
    return (
      <small className={"text-zinc-500"}>
        {paymentStatus === "void" || invoiceIssuedAt ? "Voided" : "Cancelled"}{" "}
        on {dayjs(cancelledAt).format(dateFormat)}
      </small>
    );
  }

  if (orderStage === "Voided") {
    return <small className={"text-zinc-500"}>Order voided</small>;
  }

  if ((paymentStatus === "paid" || paidAt) && orderPrice > 0) {
    return (
      <small className={"text-zinc-500"}>
        Paid on {dayjs(paidAt ?? paymentDue).format(dateFormat)}
      </small>
    );
  }

  if (invoiceIssuedAt) {
    return (
      <small className={"text-zinc-500"}>
        Issued on {dayjs(invoiceIssuedAt).format(dateFormat)}
      </small>
    );
  }

  return (
    <>
      {paymentType === "stripe" ? (
        <small className={"text-zinc-500"}>
          Drafted on {dayjs(requestedAt).format(dateFormat)}
        </small>
      ) : (
        <small className={"text-zinc-500"}>{paymentTermsText}</small>
      )}
    </>
  );
};
